// Permission constants matching backend RBAC system
export const PERMISSIONS = {
  // Projects
  PROJECTS_VIEW: 'projects.view',
  PROJECTS_CREATE: 'projects.create',
  PROJECTS_EDIT: 'projects.edit',
  PROJECTS_DELETE: 'projects.delete',
  PROJECTS_MANAGE: 'projects.manage',

  // Finance
  FINANCE_VIEW: 'finance.view',
  FINANCE_EDIT: 'finance.edit',
  FINANCE_MANAGE: 'finance.manage',

  // Timesheet
  TIMESHEET_VIEW: 'timesheet.view',
  TIMESHEET_MANAGE: 'timesheet.manage',

  // Assessments
  ASSESSMENTS_VIEW: 'assessments.view',
  ASSESSMENTS_MANAGE: 'assessments.manage',

  // Integrations
  INTEGRATIONS_VIEW: 'integrations.view',
  INTEGRATIONS_MANAGE: 'integrations.manage',

  // Users
  USERS_VIEW: 'users.view',
  USERS_CREATE: 'users.create',
  USERS_EDIT: 'users.edit',
  USERS_DELETE: 'users.delete',
  USERS_MANAGE: 'users.manage',

  // Partners
  PARTNERS_VIEW: 'partners.view',
  PARTNERS_MANAGE: 'partners.manage',

  // Clients
  CLIENTS_VIEW: 'clients.view',
  CLIENTS_CREATE: 'clients.create',
  CLIENTS_EDIT: 'clients.edit',
  CLIENTS_MANAGE: 'clients.manage',

  // AWS Access
  AWS_ACCESS_VIEW: 'aws_access.view',
  AWS_ACCESS_MANAGE: 'aws_access.manage',

  // Admin
  ADMIN_VIEW: 'admin.view',

  // CloudOps
  PLATFORMOPS_MANAGE: 'platformops.manage',

  // DataOps
  DATAOPS_MANAGE: 'dataops.manage',

  // GenAIOps
  GENAIOPS_MANAGE: 'genaiops.manage',

  // AgentOps
  AGENTOPS_MANAGE: 'agentops.manage',

  // System Admin
  SYSTEM_ADMIN: 'system.admin'
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

// Module constants
export const MODULES = {
  HUB: 'hub',
  PLATFORMOPS: 'platformops',
  DATAOPS: 'dataops',
  GENAIOPS: 'genaiops',
  AGENTOPS: 'agentops'
} as const;

export type Module = typeof MODULES[keyof typeof MODULES];

// Module descriptions for display in access management UI
export const moduleDescriptions: Record<Module, string> = {
  [MODULES.HUB]: 'Core workspace for projects, finance, and collaboration',
  [MODULES.PLATFORMOPS]: 'Cloud infrastructure and environment management',
  [MODULES.DATAOPS]: 'Data pipelines and analytics',
  [MODULES.GENAIOPS]: 'GenAI and ML operations',
  [MODULES.AGENTOPS]: 'Agent and automation management'
};

// Helper to get all permission values as array
export const getAllPermissions = (): Permission[] => Object.values(PERMISSIONS);

// Helper to check if a permission string is valid
export const isValidPermission = (permission: string): permission is Permission => {
  return (Object.values(PERMISSIONS) as string[]).includes(permission);
};

// Helper to check if a module string is valid
export const isValidModule = (module: string): module is Module => {
  return (Object.values(MODULES) as string[]).includes(module);
};
